import $ from 'jquery'
import axios from 'axios'
import auth from './auth'
import $root from './root'
import progress from './nprogress'
import { Notification } from 'element-ui'
import { prepareRetryConfig } from './api-retry'

const serverRetryLimit = 10
const serverRetryDelay = 1000
const reconnectNotificationDuration = 10000
const reloadNotificationDuration = 60000

let reconnectNotification = null
let reloadNotification = null
let activeRetryRequests = 0

function closeNotification (notification) {
  if (notification) notification.close()
}

function showReconnectNotification () {
  if (reconnectNotification) return

  reconnectNotification = Notification.warning({
    title: 'Неполадка соединения',
    message: 'Обнаружена неполадка в соединении. Идёт повторное подключение к серверу.',
    duration: reconnectNotificationDuration,
    showClose: true,
    onClose: () => {
      reconnectNotification = null
    },
  })
}

function showReloadNotification () {
  closeNotification(reconnectNotification)
  reconnectNotification = null
  if (reloadNotification) return

  reloadNotification = Notification.error({
    title: 'Не удалось подключиться к серверу',
    message: 'Все 10 попыток завершились ошибкой. Нажмите на это уведомление, чтобы перезагрузить страницу.',
    duration: reloadNotificationDuration,
    showClose: true,
    onClick: () => window.location.reload(),
    onClose: () => {
      reloadNotification = null
    },
  })
}

function isRetryableDataRequest (error) {
  const status = error.response && error.response.status
  const method = error.config && String(error.config.method || 'get').toLowerCase()

  // Повторяем только безопасное чтение: автоматический повтор POST/PUT может
  // продублировать команду модему, платёж или другое изменение состояния.
  return method === 'get' && (status === 500 || status === 502)
}

function startRetrying (config) {
  if (config.serverRetryActive) return

  // Несколько параллельных GET используют одно уведомление. Счётчик не даёт
  // успешному запросу закрыть его, пока остальные запросы ещё восстанавливаются.
  config.serverRetryActive = true
  activeRetryRequests++
}

function finishRetrying (config) {
  if (!config || !config.serverRetryActive) return

  config.serverRetryActive = false
  activeRetryRequests = Math.max(activeRetryRequests - 1, 0)
  if (activeRetryRequests === 0) {
    closeNotification(reconnectNotification)
    reconnectNotification = null
  }
}

function retryRequest (error) {
  const config = prepareRetryConfig(error.config)
  startRetrying(config)
  config.serverRetryCount = (config.serverRetryCount || 0) + 1

  if (config.serverRetryCount > serverRetryLimit) {
    finishRetrying(config)
    showReloadNotification()
    return Promise.reject(error)
  }

  showReconnectNotification()

  return new Promise(resolve => setTimeout(resolve, serverRetryDelay))
    .then(() => api.request(config))
}

const api = axios.create({
  // baseURL: 'https://api.vendoscope.pro/',
  baseURL: '/api/admin/',
  paramsSerializer: $.param,
  headers: {
    common: {
      // 'X-CSRF-TOKEN': window.Laravel.csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
    },
  },
})
progress.use(api)

api.interceptors.response.use(response => {
  if (response.config && response.config.serverRetryCount) {
    finishRetrying(response.config)
  }

  // Update release
  if (response && response.headers && response.headers.release) {
    if ($root) {
      $root.release = response.headers.release
    }
  }
  return response
}, error => {
  if (isRetryableDataRequest(error)) {
    return retryRequest(error)
  }

  finishRetrying(error.config)

  // Go to login when api returns Unauthenticated response
  // for any request except oauth login
  if (error.response && error.response.status === 401) {
    auth.afterLogout()

    return Promise.reject(error)
  }

  // The request was made and the server responded with a status code that falls out of the range of 2xx
  // if (error.response) {
  //   // We've catch the Upstream error! Or something not found in Upstream service
  //   if (error.response.data.error === 'upstream_error' && error.response.status === 502) {
  //     $root.showAlert(error.response.data.message)
  //   } else if (error.response.data.error === 'upstream_not_found' && error.response.status === 404) {
  //     $root.showAlert(error.response.data.message)
  //   } else {
  //     // Or something really bad happened from our Proxy..
  //     $root.showAlert('Ошибка при выполнении запроса')
  //   }
  //
  //   return Promise.reject(error)
  // } else if (error.request) {
  //   // The request was made but no response was received
  //   $root.showAlert('Ошибка при выполнении запроса')
  // } else if (error.response === undefined && error.message === 'Network Error') {
  //   // No internet connection
  //   $root.showAlert('Ошибка при выполнении запроса')
  // } else {
  //   // Something happened in setting up the request that triggered an Error
  //   $root.showAlert('Ошибка при выполнении запроса')
  // }

  return Promise.reject(error)
})

export default api



// WEBPACK FOOTER //
// ./resources/assets/js/api.js